import createReducer from './utils/createReducer';
import * as c from '../constants/actions';

const initialState = {
  data: {},
  light: [],
  isLoading: false,
  error: null,
};

export default createReducer(initialState, {
  [c.GET_OPERATORS_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.GET_OPERATORS_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: payload,
    error: null,
    isLoading: false,
  }),
  [c.GET_OPERATORS_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.CREATE_OPERATOR_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.CREATE_OPERATOR_SUCCESS]: state => ({
    ...state,
    error: null,
    isLoading: false,
  }),
  [c.CREATE_OPERATOR_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.UPDATE_OPERATOR_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.UPDATE_OPERATOR_SUCCESS]: (state, { payload }) => ({
    ...state,
    data: {
      ...state.data,
      data: state.data.data.map(el => (el.id === payload.id
        ? { ...el, ...payload }
        : el
      ))
    },
    error: null,
    isLoading: false,
  }),
  [c.UPDATE_OPERATOR_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.DELETE_OPERATOR_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.DELETE_OPERATOR_SUCCESS]: state => ({
    ...state,
    error: null,
    isLoading: false,
  }),
  [c.DELETE_OPERATOR_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
  [c.GET_OPERATORS_LIGHT_REQUEST]: state => ({
    ...state,
    error: null,
    isLoading: true,
  }),
  [c.GET_OPERATORS_LIGHT_SUCCESS]: (state, { payload }) => ({
    ...state,
    light: payload,
    error: null,
    isLoading: false,
  }),
  [c.GET_OPERATORS_LIGHT_ERROR]: (state, { payload }) => ({
    ...state,
    error: payload,
    isLoading: false,
  }),
});
